import {formatCurrency} from "../../common/Utils";
import React, {useContext, useState} from "react";
import {
  updateMemberPerkItem
} from "../../common/api/PortalCustomerApi";
import {CONSTANTS} from "../../common/constants";
import MDInput from "../../../components/MDInput";
import {InputAdornment} from "@mui/material";
import MDButton from "../../../components/MDButton";

export default function CartPerks({cart, getCartFullFn}) {

  const togglePerk = (item) => {
    item.applied = !!!item.applied;
    updateMemberPerkItem(item).then((resp) => {
      getCartFullFn()
    });
  }

  const displayPerk = (perk) => {
    return perk.name;
  }

  const applyPerkCredit = (item) => {
    let _item = {...item};
    _item.creditApplied = parseFloat(_item.creditApplied);
    updateMemberPerkItem(_item).then((resp) => {
      getCartFullFn()
    });
  }

  const [perkCreditValue, setPerkCreditValue] = useState(undefined)
  const [appliedPerkDiscount, setAppliedPerkDiscount] = useState();

  const [renderIndex, setRenderIndex] = useState(1);
  const perkValueChange = (perk, value, warn) => {
    let _cart = {...cart};
    _cart.memberPerks.map((p, idx) => {
      if (perk.id === p.id) {
        perk.creditApplied = value;
        perk.perkWarning = null;
        if (warn) {
          perk.perkWarning = warn;
        }
      }
    });
    setRenderIndex(renderIndex + 1)
  }

  return (
    <>
      {cart && cart?.memberPerks
        .sort((a, b) => a.id - b.id)
        .map((item, index) => {
          return (
            <div className={'psb-bordered my-2'} key={index} style={{
              background: '#f6f1f1'
            }}>
              <h6>
                You have a Member Perk available
              </h6>
              <p>
                <small>
                  <b>Perk Type:</b> {item?.name}
                  <br/>
                  {item?.storeCreditBalance && <>
                    <b>Balance:</b> {formatCurrency(item?.storeCreditBalance)}
                    <br/>
                  </>}
                  {item?.perkType?.id !== CONSTANTS.PERK_TYPE.CREDIT &&
                    <MDButton className={'mt-3'} color="secondary" size={'small'} onClick={()=>{
                      togglePerk(item);
                    }}>Apply member perk</MDButton>
                  }
                </small>
              </p>

              {item?.perkType?.id === CONSTANTS.PERK_TYPE.CREDIT && <>
              {renderIndex > 0 && <>
                <div className="input-group my-2">
                  <MDInput type={'text'}
                           value={item?.creditApplied > 0 ? parseFloat(item?.creditApplied).toFixed(2) : ''}
                           placeholder={(parseFloat(cart?.appliedDiscountAmount).toFixed(2) || parseFloat(item.storeCreditValue).toFixed(2) + ' ')}
                           onChange={(e) => {
                             let _amount = e.target.value;
                             _amount = e.target.value.replace(/[^0-9.]/g, '');
                             let cents = _amount.split('.');
                             if (cents[1]?.length > 2) {
                               _amount = parseFloat(_amount).toFixed(2);
                             }
                             let perkWarn = null;
                             if (_amount > parseFloat(item.storeCreditValue)) {
                               _amount = parseFloat(item.storeCreditValue);
                               perkWarn = 'Amount entered exceeds allowed value';
                             }
                             perkValueChange(item, _amount, perkWarn);
                           }}
                           InputProps={{
                             startAdornment: <InputAdornment position="start">
                               <b>$</b>
                             </InputAdornment>,
                           }}/>

                  <button className="btn btn-secondary" type="button" onClick={() => {
                    applyPerkCredit(item)
                  }}
                          style={{
                            border: 'solid 1px #ddd'
                          }}
                          disabled={!item?.creditApplied}
                          id="button-addon1">Apply
                  </button>
                  {item?.perkWarn}
                </div>
              </>}

              </>
              }
            </div>
          )
        })
      }
    </>
  )
}